import { __ } from '@wordpress/i18n';
import {
    useBlockProps,
    MediaUpload,
    MediaUploadCheck,
    InspectorControls
} from '@wordpress/block-editor';

import {
    Button,
    PanelBody,
    SelectControl,
    RangeControl,
    CheckboxControl
} from '@wordpress/components';

import './editor.scss';

export default function Edit({ attributes, setAttributes }) {
    const {
        images,
        layout,
        spacing,
        columns,
        enableLightbox
    } = attributes;

    const onSelectImages = (newImages) => {
        setAttributes({
            images: newImages.map((img) => ({
                id: img.id,
                url: img.url,
                alt: img.alt
            }))
        });
    };

    return (
        <div {...useBlockProps()}>
            <InspectorControls>

                <PanelBody
                    title={__('Gallery Settings', 'pixelnest-blocks')}
                    initialOpen={true}
                >
                    <MediaUploadCheck>
                        <MediaUpload
                            onSelect={onSelectImages}
                            allowedTypes={['image']}
                            multiple
                            gallery
                            value={images?.map((img) => img.id)}
                            render={({ open }) => (
                                <Button onClick={open} variant="primary">
                                    {images?.length
                                        ? __('Edit Gallery', 'pixelnest-blocks')
                                        : __('Select Images', 'pixelnest-blocks')}
                                </Button>
                            )}
                        />
                    </MediaUploadCheck>
                </PanelBody>

                <PanelBody
                    title={__('Layout Options', 'pixelnest-blocks')}
                    initialOpen={false}
                >
                    <SelectControl
                        label={__('Layout', 'pixelnest-blocks')}
                        value={layout}
                        options={[
                            { label: __('Grid', 'pixelnest-blocks'), value: 'grid' },
                            { label: __('Masonry', 'pixelnest-blocks'), value: 'masonry' }
                        ]}
                        onChange={(newLayout) =>
                            setAttributes({ layout: newLayout })
                        }
                    />

                    <RangeControl
                        label={__('Spacing (px)', 'pixelnest-blocks')}
                        value={spacing}
                        onChange={(newSpacing) =>
                            setAttributes({ spacing: newSpacing })
                        }
                        min={0}
                        max={50}
                        __next40pxDefaultSize
                        __nextHasNoMarginBottom
                    />

                    <RangeControl
                        label={__('Columns', 'pixelnest-blocks')}
                        value={columns}
                        onChange={(newColumns) =>
                            setAttributes({ columns: newColumns })
                        }
                        min={1}
                        max={6}
                        __next40pxDefaultSize
                        __nextHasNoMarginBottom
                    />

                    <CheckboxControl
                        label={__('Enable Lightbox?', 'pixelnest-blocks')}
                        checked={enableLightbox}
                        onChange={(value) =>
                            setAttributes({ enableLightbox: value })
                        }
                        __nextHasNoMarginBottom
                    />
                </PanelBody>

            </InspectorControls>

            <div
                className={`gallery-preview ${layout}`}
                style={{
                    '--row-gap': `${spacing}px`,
                    '--column-gap': `${spacing}px`,
                    columnCount: layout === 'masonry' ? columns : undefined,
                    gridTemplateColumns:
                        layout === 'grid'
                            ? `repeat(${columns}, 1fr)`
                            : undefined
                }}
            >
                {images?.length ? (
                    images.map((img) => (
                        <div key={img.id} className="gallery-img">
                            <img src={img.url} alt={img.alt} />
                        </div>
                    ))
                ) : (
                    <p>{__('No images selected yet.', 'pixelnest-blocks')}</p>
                )}
            </div>
        </div>
    );
}
